export default __webpack_public_path__ + "static/fully-bitemporal-b3ed67afb54ff072b97a5b7bed906be5.png";